import React, {useContext, useEffect, useState} from "react";
import PrintLogo from "../common/PrintLogo";
import Img from "../../common/Img";
import TranscriptSemesterTable from "./_TranscriptSemesterTable";
import MoheLogo from "../common/MoheLogo";
import db from "../../../services/query";
import queryString from "query-string";

const Transcript = (props) => {

    let orientation;

    const formatDate = (dateStr) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        let theDate = new Date(Date.parse(dateStr));
        let dd = String(theDate.getDate()).padStart(2, "0");
        let mm = theDate.getMonth();
        let yyyy = theDate.getFullYear();

        return `${dd} ${monthNames[mm]} ${yyyy}`;
    };

    const renderSemesterTable = (data, index, count) => {
        // dynamically generate tables
        let res = [];
        if(data?.data) {
            for(let ndx = index; ndx<(index+count); ndx++){
                const semester = data?.data[ndx];
                if(semester) {
                    // make tables fixed row (exactly 7 rows)
                    for (let i = semester?.subjects?.length; i < 7; i++) {
                        semester?.subjects?.push({subject_code: ''})
                    }


                    res.push(<TranscriptSemesterTable
                        data={semester}
                        columns={columns}
                        title={semester.class_desc_en + ' | ' + semester.entry_year_en}
                        summary={semester?.subjects_summary}
                    />);
                }
            }
        }

        return res;
    };


    const columns = [
        {path: "GPA", label: "GPA"},
        {path: "grade", label: "GRADE"},
        {path: "total", label: "MARKS"},
        {path: "credits", label: "CREDITS"},
        {path: "subject_name", label: "SUBJECT"},
        {path: "subject_code", label: "CODE"},
    ];

    const [data, updateData] = useState([]);
    const [student, updateStudent] = useState([]);

    useEffect(async () => {
        const ac = new AbortController();
        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        const {studentId} = props.match.params;

        await db.getAll(`results/students/${studentId}`).then(({data}) => {
            updateData(data);
            if (data?.data?.length > 8) orientation = 'l';
        });

        await db.getAll(`students/${studentId}`).then(({data}) => {
            updateStudent(data?.data[0]);
        });

    };

    return (
        <main className={`main-print-wrapper  transcript-portrait`}>
            {/* Header */}
            <div className="print-header">
                <MoheLogo/>
                <div id="transcript-title-aria" style={{textAlign: "center", minWidth: "35%"}}>
                    <p style={{letterSpacing: "1px"}}>MINISTRY OF HIGHER EDUCATION</p>
                    <p style={{letterSpacing: "10px"}}>ARIA UNIVERSITY</p>
                    <p style={{letterSpacing: "5px", fontWeight: "bold"}}>ACADEMIC TRANSCRIPT</p>
                </div>
                <PrintLogo/>
            </div>

            {/* Student Info */}
            <div style={{display: "grid", gridTemplateColumns: "30% 30% 30%", placeContent: "center", marginBottom: "50px"}}>
                <div style={{display: "grid", gridTemplateColumns: "50% 50%", placeContent: "revert"}}>
                    <div className="print-identity-card right">
                        <div className="wrapper">
                            <p>Student Name</p>
                            <h4>{student?.student_name_en}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card right">
                        <div className="wrapper">
                            <p>Student ID</p>
                            <h4>{student?.aria_id}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card right">
                        <div className="wrapper">
                            <p>Father's Name</p>
                            <h4>{`${student?.student_father_name_en}  ${student?.student_lastname_en}`}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card right">
                        <div className="wrapper">
                            <p>Faculty</p>
                            <h4>{student?.faculty_name_en}</h4>
                        </div>
                    </div>
                </div>
                <div className="print-profile" style={{height: "auto"}}>
                    <Img src={student?.student_photo} alt=""/>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "50% 50%", placeContent: "revert"}}>
                    <div className="print-identity-card left">
                        <div className="wrapper">
                            <p>Start Date</p>
                            <h4>{formatDate('3 Mar 2021')}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card left">
                        <div className="wrapper">
                            <p>Date of Birth</p>
                            <h4>{formatDate(student?.student_dob)}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card left">
                        <div className="wrapper">
                            <p>Completion Date</p>
                            <h4>{formatDate('3 Mar 2021')}</h4>
                        </div>
                    </div>
                    <div className="print-identity-card left">
                        <div className="wrapper">
                            <p>Date of Issue</p>
                            <h4>{formatDate('3 Mar 2021')}</h4>
                        </div>
                    </div>
                </div>
            </div>

            {/* Marks Tables page 1 */}
            <div className="transcript-table-container"
                 style={{display: "grid", gridTemplateColumns: "calc(50% - 10px) calc(50% - 10px)", gap: "20px", marginTop: "70px"}}>
                {renderSemesterTable(data, 0, orientation == 'p' ? 6 : 4).map((table)=>table)}
                {/*{renderSemesterTable(data, 0,  6).map((table)=>table)}*/}
            </div>


            <div style={{pageBreakBefore: "always"}}></div>

            {/* Marks Tables page 2 */}
            <div className="transcript-table-container"
                 style={{display: "grid", gridTemplateColumns: "calc(50% - 10px) calc(50% - 10px)", gap: "20px", paddingTop: "70px"}}>
                {renderSemesterTable(data, orientation == 'p' ? 6 : 4, data?.data?.length).map((table)=>table)}
                {/*{renderSemesterTable(data, 0,  6).map((table)=>table)}*/}
            </div>

            {/* Marks Summary*/}
            <div style={{display: "grid", gridTemplateColumns: "48% 48%", gap: "4%", marginTop: "10px"}}>
                <p style={{color: "var(--font-color)", fontSize: "13px", fontWeight: "normal"}}>
                    All courses are evaluated in 100 marks.<br/>
                    This document is not valid without signature and stamp. <br/>
                    پوهنتون آریا reserves the right to correct any error made inadvertently in result sheet.</p>

                <div style={{display: "grid", gridTemplateColumns: "48% 48%", gap: "4%"}}>
                    <div style={{display: "grid", gridTemplateColumns: "70% 30%"}}>
                        <p style={{
                            textAlign: "left",
                            color: "var(--font-color)",
                            fontSize: "13px",
                            fontWeight: "normal"
                        }}>Total Credit Hours</p>
                        <h3 style={{
                            textAlign: "right",
                            color: "var(--font-color)",
                            fontSize: "15px"
                        }}>{data?.summary?.overall_credits}</h3>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "70% 30%"}}>
                        <p style={{
                            textAlign: "left",
                            color: "var(--font-color)",
                            fontSize: "13px",
                            fontWeight: "normal"
                        }}>Average Marks</p>
                        <h3 style={{textAlign: "right", color: "var(--font-color)", fontSize: "15px"}}>{data?.summary?.overall_avg_marks}</h3>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "70% 30%"}}>
                        <p style={{
                            textAlign: "left",
                            color: "var(--font-color)",
                            fontSize: "13px",
                            fontWeight: "normal"
                        }}>Marks Obtained</p>
                        <h3 style={{
                            textAlign: "right",
                            color: "var(--font-color)",
                            fontSize: "15px"
                        }}>{data?.summary?.overall_marks}</h3>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "70% 30%"}}>
                        <p style={{
                            textAlign: "left",
                            color: "var(--font-color)",
                            fontSize: "13px",
                            fontWeight: "normal"
                        }}>CGPA</p>
                        <h3 style={{
                            textAlign: "right",
                            color: "var(--font-color)",
                            fontSize: "15px"
                        }}>{data?.summary?.overall_gpa}</h3>
                    </div>
                </div>
            </div>

            {/* Signature area */}
            <div style={{display: "grid", gridTemplateColumns: "auto auto auto", marginTop: "150px"}}>
                <div className="print-identity-card">
                    <div className="wrapper">
                        <p>Chancellor</p>
                        <h3>PROF. M. ZAHIR HAIDARI</h3>
                    </div>
                </div>
                <div className="print-identity-card">
                    <div className="wrapper">
                        <p>Voice Chancellor</p>
                        <h3>ASIF SHIRZAD</h3>
                    </div>
                </div>
                <div className="print-identity-card">
                    <div className="wrapper">
                        <p>Dean Of Faculty</p>
                        <h3>M.NASER AMINI</h3>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Transcript;
